var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app"},[_c('header',[_c('Navigation')],1),_c('main',{staticStyle:{"padding":"0 15px"}},[_c('content',[_vm._t("default")],2),_c('footer')])])
}
var staticRenderFns = []

export { render, staticRenderFns }